module.exports = __webpack_public_path__ + "static/media/ceo.67fec477.jpg";